export const IPInfoReducer = (state = {}, action) => {
    switch (action.type) {
      case "IP_INFO":
        return { ...action.payload };
      default:
        return state;
    }
  };